var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogeBoxMobFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 166,
    viewBox: "0 0 234 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8899 137.56L19.7899 130.66L19.6699 137.56H12.8899Z",
    fill: "#D2B367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0341 130.085C20.2686 130.184 20.4192 130.416 20.4148 130.671L20.2948 137.571C20.2889 137.912 20.0109 138.185 19.6699 138.185H12.8899C12.6371 138.185 12.4092 138.033 12.3125 137.799C12.2157 137.566 12.2692 137.297 12.448 137.118L19.348 130.218C19.5281 130.038 19.7996 129.985 20.0341 130.085ZM14.3988 136.935H19.0557L19.1381 132.196L14.3988 136.935Z",
    fill: "#020202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M11.99 137.56L18.89 130.66L18.77 137.56H11.99Z",
    fill: "#020202"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.59 109.67H218.68V112.47L221.59 109.67Z",
    fill: "#020202"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.055 109.67C218.055 109.325 218.335 109.045 218.68 109.045H221.59C221.845 109.045 222.074 109.2 222.17 109.436C222.265 109.673 222.207 109.944 222.023 110.12L219.113 112.92C218.933 113.094 218.666 113.143 218.435 113.045C218.205 112.947 218.055 112.721 218.055 112.47V109.67ZM219.305 110.295V111.001L220.039 110.295H219.305Z",
    fill: "#020202"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.68 14.72L188.68 44.97V147.47L218.68 117.22V14.72Z",
    fill: "#F9F0DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.918 14.1421C219.152 14.2385 219.305 14.4667 219.305 14.72V117.22C219.305 117.385 219.24 117.543 219.124 117.66L189.124 147.91C188.945 148.09 188.676 148.144 188.442 148.048C188.208 147.951 188.055 147.723 188.055 147.47V44.97C188.055 44.8051 188.12 44.6469 188.236 44.5299L218.236 14.2799C218.414 14.1001 218.684 14.0456 218.918 14.1421ZM189.305 45.2274V145.952L218.055 116.963V16.2378L189.305 45.2274Z",
    fill: "#020202"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 22.8963C219.365 23.1394 219.367 23.5351 219.124 23.7802L189.124 54.0302C188.881 54.2753 188.485 54.2769 188.24 54.0339C187.995 53.7908 187.993 53.3951 188.236 53.15L218.236 22.9C218.479 22.6549 218.875 22.6533 219.12 22.8963Z",
    fill: "#020202"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 32.1063C219.365 32.3493 219.367 32.7451 219.124 32.9902L189.124 63.2402C188.881 63.4852 188.485 63.4869 188.24 63.2438C187.995 63.0008 187.993 62.605 188.236 62.3599L218.236 32.1099C218.479 31.8649 218.875 31.8632 219.12 32.1063Z",
    fill: "#020202"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 42.6263C219.365 42.8694 219.367 43.2651 219.124 43.5102L189.124 73.7602C188.881 74.0053 188.485 74.0069 188.24 73.7638C187.995 73.5208 187.993 73.1251 188.236 72.88L218.236 42.63C218.479 42.3849 218.875 42.3832 219.12 42.6263Z",
    fill: "#020202"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 51.8363C219.365 52.0794 219.367 52.4752 219.124 52.7202L189.124 82.9602C188.881 83.2053 188.485 83.2068 188.24 82.9637C187.995 82.7206 187.993 82.3249 188.236 82.0798L218.236 51.8399C218.479 51.5948 218.875 51.5932 219.12 51.8363Z",
    fill: "#020202"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 61.5462C219.365 61.7893 219.367 62.185 219.124 62.4301L189.124 92.6801C188.881 92.9252 188.485 92.9268 188.24 92.6838C187.995 92.4407 187.993 92.045 188.236 91.7999L218.236 61.5499C218.479 61.3048 218.875 61.3032 219.12 61.5462Z",
    fill: "#020202"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 71.6463C219.365 71.8894 219.367 72.2851 219.124 72.5302L189.124 102.78C188.881 103.025 188.485 103.027 188.24 102.784C187.995 102.541 187.993 102.145 188.236 101.9L218.236 71.65C218.479 71.4049 218.875 71.4033 219.12 71.6463Z",
    fill: "#020202"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 82.0762C219.365 82.3193 219.367 82.715 219.124 82.9601L189.124 113.21C188.881 113.455 188.485 113.457 188.24 113.214C187.995 112.971 187.993 112.575 188.236 112.33L218.236 82.0799C218.479 81.8348 218.875 81.8332 219.12 82.0762Z",
    fill: "#020202"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 91.9063C219.365 92.1494 219.367 92.5451 219.124 92.7902L189.124 123.04C188.881 123.285 188.485 123.287 188.24 123.044C187.995 122.801 187.993 122.405 188.236 122.16L218.236 91.91C218.479 91.6649 218.875 91.6633 219.12 91.9063Z",
    fill: "#020202"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.12 101.896C219.365 102.139 219.367 102.535 219.124 102.78L189.124 133.02C188.881 133.265 188.485 133.267 188.24 133.024C187.995 132.781 187.993 132.385 188.236 132.14L218.236 101.9C218.479 101.655 218.875 101.653 219.12 101.896Z",
    fill: "#020202"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M188.68 44.97H19.6699V137.47H188.68V44.97Z",
    fill: "#F9F0DC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0449 44.97C19.0449 44.6248 19.3247 44.345 19.6699 44.345H188.68C189.025 44.345 189.305 44.6248 189.305 44.97V137.47C189.305 137.815 189.025 138.095 188.68 138.095H19.6699C19.3247 138.095 19.0449 137.815 19.0449 137.47V44.97ZM20.2949 45.595V136.845H188.055V45.595H20.2949Z",
    fill: "#020202"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M192.65 137.56H12.8899V151.45H192.65V137.56Z",
    fill: "#D2B367"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2649 137.56C12.2649 137.215 12.5447 136.935 12.8899 136.935H192.65C192.995 136.935 193.275 137.215 193.275 137.56V151.45C193.275 151.795 192.995 152.075 192.65 152.075H12.8899C12.5447 152.075 12.2649 151.795 12.2649 151.45V137.56ZM13.5149 138.185V150.825H192.025V138.185H13.5149Z",
    fill: "#020202"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M221.59 122.61L192.65 151.45V137.56L221.59 109.67V122.61Z",
    fill: "#D2B367"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.834 109.095C222.065 109.193 222.215 109.419 222.215 109.67V122.61C222.215 122.776 222.149 122.935 222.031 123.053L193.091 151.893C192.912 152.071 192.644 152.124 192.41 152.027C192.177 151.93 192.025 151.703 192.025 151.45V137.56C192.025 137.39 192.094 137.228 192.216 137.11L221.156 109.22C221.337 109.046 221.604 108.997 221.834 109.095ZM193.275 137.826V149.945L220.965 122.35V111.14L193.275 137.826Z",
    fill: "#020202"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M221.59 122.61L192.65 151.45V137.56L221.59 109.67V122.61Z",
    fill: "#020202"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogeBoxMobFront);
export default __webpack_public_path__ + "static/media/doge-box-mob-front.b9f03cc5a9d97c78f48951797f53c563.svg";
export { ForwardRef as ReactComponent };